import { Ref } from "react";

export const saveToRef = <T>(ref: Ref<T> | undefined, element: T | null) => {
    if (ref) {
        if (typeof ref === "function") {
            ref(element);
        }
        else {
            ref.current = element;
        }
    }
};

export const combineRefs =
    <T>(refs: (Ref<T> | undefined)[]) =>
    (data: T | null) => {
        for (const ref of refs) {
            saveToRef(ref, data);
        }
    };
